import {
	Box,
	Dialog as DialogMui,
	DialogProps as DialogPropsMui,
} from '@mui/material';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import palette from 'styles/theme/Palette';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import DialogActions from './DialogActions';
import DialogContent from './DialogContent';
import DialogTitle from './DialogTitle';

type DialogProps = DialogPropsMui & {
	title: string;
	variant: 'dialog' | 'confirm' | 'uploadFileDialog';
	actions: React.ReactNode;
	close: React.ReactNode;
	events: boolean;
	type: string;
};

const StyledDialog = styled(DialogMui)``;

const Dialog: React.FC<DialogProps> = props => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { title, variant, actions, close, events, type, ...dialogProps } = props;

	let cookiesText;
	if (props.type === 'cookiesDialog') {
		cookiesText = (
			<Box>
				{tClientLabels('dialog.confirm.cookies.content1')}{' '}
				<Link
					to="https://www.google.com"
					target="_blank"
					style={{
						color: palette.primary.main,
						fontWeight: 700,
						textDecoration: 'underline',
					}}
				>
					{tClientLabels('dialog.confirm.cookies.content2')}
				</Link>{' '}
				{tClientLabels('dialog.confirm.cookies.content3')}
			</Box>
		);
	}
	return (
		<StyledDialog {...dialogProps} PaperProps={{ variant: variant }}>
			<DialogTitle title={title} children={close} />
			<DialogContent>
				{type === 'cookiesDialog' ? cookiesText : dialogProps.children}
			</DialogContent>
			{!!events && <DialogActions>{actions}</DialogActions>}
		</StyledDialog>
	);
};

export default Dialog;
